/** SLOC Updation — the desk's forms: Sub-bin wise, or Crop Variety wise (the one-lot move). */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { SlocNewPage } from "@/features/warehouse/components/sloc-new-page";
import { SlocSubBinPage } from "@/features/warehouse/components/sloc-subbin-page";
import { asStage, useDeskFacility } from "@/features/warehouse/route-helpers";
import { guardDesk } from "../../-guard";

const search = z.object({
  mode: z.enum(["subbin", "lot"]).optional().catch(undefined),
  /** Sub-bin wise's hand-off: open Crop Variety wise on this lot, moving from this SLOC. */
  lotId: z.coerce.number().int().positive().optional().catch(undefined),
  fromLocationId: z.coerce
    .number()
    .int()
    .positive()
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute("/_app/warehouse/$stage/sloc/new")({
  validateSearch: search,
  beforeLoad: ({ params, search: s }) => {
    guardDesk(params.stage, undefined, "sloc");
    // Which screen is the chooser's second question: no answer, ask it.
    if (!s.mode)
      throw redirect({
        to: "/warehouse/sloc",
        search: { stage: asStage(params.stage) },
      });
  },
  component: Page,
});

function Page() {
  const { stage } = Route.useParams();
  const s = Route.useSearch();
  const facilityId = useDeskFacility();
  return s.mode === "subbin" ? (
    <SlocSubBinPage stage={asStage(stage)} facilityId={facilityId} />
  ) : (
    <SlocNewPage
      key={`${s.lotId ?? ""}-${s.fromLocationId ?? ""}`}
      stage={asStage(stage)}
      facilityId={facilityId}
      prefill={
        s.lotId
          ? { lotId: s.lotId, fromLocationId: s.fromLocationId ?? null }
          : undefined
      }
    />
  );
}
